export const ERROR_CODES = {
    SCHEMA_VALIDATION_FAILED: 'SCHEMA_VALIDATION_FAILED',
    PATTERN: 'PATTERN',
    MALICIOUS_STRING: 'MALICIOUS_STRING',
};
